import React from 'react'
import { StyledStoryContainer } from './styles.style'
import Modal from '../../../../components/modal/modal.component'
import { PlayButton } from '../../../../components/buttons/buttons.component'
import videoInstructions from '../../../../../assets/images/video-instructions.png'

class HistoryPage extends React.Component {
	constructor(props) {
		super(props)
		this.storyContainer = null
		this.state = {
			showVideoModal: false,
		}
	}

	render() {
		return (
			<StyledStoryContainer
				id="sobre"
				innerRef={elem => (this.storyContainer = elem)}>
				<div className="story-title">
					<h2 className="blue">Viajar de ônibus é <b>bom</b> e <b>barato</b>!</h2>
				</div>
				<div className="video-container">
					<PlayButton
						onClick={() =>
							this.setState({
								showVideoModal: true
							})
						}
					/>
					<img
						src={videoInstructions}
						alt="Clique aqui para assistir ao vídeo"
					/>
				</div>
				<Modal
					noPadding
					animation="jackInTheBox"
					isOpen={this.state.showVideoModal}
					onClose={() => this.setState({ showVideoModal: false })}>
					<iframe
						width="560"
						height="315"
						frameBorder="0"
						allow="autoplay; encrypted-media"
						allowFullScreen="allowFullScreen"
						oallowfullscreen="oallowfullscreen"
						msallowfullscreen="msallowfullscreen"
						mozallowfullscreen="mozallowfullscreen"
						webkitallowfullscreen="webkitallowfullscreen"
						src="https://www.youtube.com/embed/W6kKWT3PCAk?rel=0;autoplay=1;wmode=transparent;"
					/>
				</Modal>
			</StyledStoryContainer>
		)
	}
}

export default HistoryPage
